import styled, { css } from 'styled-components'

const noframe = () => css`
  border: none;
`
const frame = w => css`
  border: ${w}px solid #707070;
`
const passePartout = w => css`
  border: ${w}px solid #707070;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: ${w}px solid #e6e6e6;
  }
`

export const SampleFrame = styled.div`
  display: block;
  background-color: #ffffff;

  width: ${props => props.w}px;
  height: ${props => props.h}px;

  border-radius: 0;
  ${props => props.f === 'noframe' && noframe()};
  ${props => props.f === 'frame' && frame(props.b)};
  ${props => props.f === 'passe-partout' && passePartout(props.b)};
  ${props => props.f === 'passe-partout-deluxe' && passePartout(props.b)};
`

export const InfoBox = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  display: block;
  width: 100%;
  min-height: 25px;
  padding: 5px;
  border-top: 1px solid rgba(0, 0, 0, 0.3);
  background-color: ${props => props.theme.colors.white};
`

export const InfoText = styled.p`
  display: block;
  width: 100%;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  margin: 0;
  color: black;
`

export const MagnifierLink = styled.a`
  position: absolute;
  top: -5px;
  right: -5px;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(54, 124, 255, 0.4);
  border-radius: 50%;
  color: #e5e5e5;
  opacity: 0;
  transition: all 0.3s ease;

  &:hover {
    color: #e5e5e5;
    background: rgba(54, 124, 255, 1);
  }
`



// WEBPACK FOOTER //
// ./src/components/Frame/theme.js